import {
  SelectFormWrap,
  SelectCustom,
  OptionCustom,
} from "src/styles/common/CommonForm/selectform";
import React from "react";
import { useRecoilState } from "recoil";
import { RefundTypeState } from "src/store/recoil/refund";
export const BankList = [
  "기업은행",
  "국민은행",
  "신한은행",
  "우리은행",
  "KEB하나은행",
  "농협은행",
  "지역농축협",
  "SC제일은행",
  "한국시티은행",
  "우체국",
  "경남은행",
  "광주은행",
  "대구은행",
  "도이치",
  "부산은행",
  "산림조합",
  "산업은행",
  "저축은행",
  "새마을금고",
  "수협",
  "신협",
  "전북은행",
  "제주은행",
  "BOA",
  "HSBC",
  "JP모간",
  "중국공상은행",
  "비엔피파리바은행",
  "중국건설은행",
  "카카오뱅크",
  "케이뱅크",
  "교보증권",
  "대신증권",
  "미래에셋대우",
  "DB금융투자",
  "유안타증권",
  "메리츠증권",
  "부국증권",
  "삼성증권",
  "솔로몬투자증권",
  "신영증권",
  "신한금융투자",
  "NH투자증권",
  "유진투자증권",
  "이베스트증권",
  "키움증권",
  "하나금융투자",
  "하이투자",
  "한국투자",
  "한화증권",
  "KB증권",
  "현대차투자증권",
  "토스뱅크",
  "케이프투자증권",
  "SK증권",
  "KTB투자증권",
  "한국포스증권",
];
const SelectForm = (props: any) => {
  const { title } = props;
  const [refundType, setRefundType] = useRecoilState(RefundTypeState);
  const selectOption = [
    { idx: 0, value: "none", text: "은행을 선택해주세요." },
    { idx: 1, value: "국민은행", text: "국민은행" },
    { idx: 2, value: "신한은행", text: "신한은행" },
    { idx: 3, value: "우리은행", text: "우리은행" },
    { idx: 4, value: "KEB하나은행", text: "KEB하나은행" },
    { idx: 5, value: "농협은행", text: "농협은행" },
    { idx: 6, value: "지역농축협", text: "지역농축협" },
    { idx: 7, value: "SC제일은행", text: "SC제일은행" },
    { idx: 8, value: "한국시티은행", text: "한국시티은행" },
    { idx: 9, value: "우체국", text: "우체국" },
    { idx: 10, value: "경남은행", text: "경남은행" },
    { idx: 11, value: "광주은행", text: "광주은행" },
    { idx: 12, value: "대구은행", text: "대구은행" },
    { idx: 13, value: "도이치", text: "도이치" },
    { idx: 14, value: "부산은행", text: "부산은행" },
    { idx: 15, value: "산림조합", text: "산림조합" },
    { idx: 16, value: "산업은행", text: "산업은행" },
    { idx: 17, value: "저축은행", text: "저축은행" },
    { idx: 18, value: "새마을금고", text: "새마을금고" },
    { idx: 19, value: "수협", text: "수협" },
    { idx: 20, value: "신협", text: "신협" },
    { idx: 21, value: "전북은행", text: "전북은행" },
    { idx: 22, value: "제주은행", text: "제주은행" },
    { idx: 23, value: "BOA", text: "BOA" },
    { idx: 24, value: "HSBC", text: "HSBC" },
    { idx: 25, value: "JP모간", text: "JP모간" },
    { idx: 26, value: "중국공상은행", text: "중국공상은행" },
    { idx: 27, value: "비엔피파리바은행", text: "비엔피파리바은행" },
    { idx: 28, value: "중국건설은행", text: "중국건설은행" },
    { idx: 29, value: "카카오뱅크", text: "카카오뱅크" },
    { idx: 30, value: "케이뱅크", text: "케이뱅크" },
    { idx: 31, value: "교보증권", text: "교보증권" },
    { idx: 32, value: "대신증권", text: "대신증권" },
    { idx: 33, value: "미래에셋대우", text: "미래에셋대우" },
    { idx: 34, value: "DB금융투자", text: "DB금융투자" },
    { idx: 35, value: "유안타증권", text: "유안타증권" },
    { idx: 36, value: "메리츠증권", text: "메리츠증권" },
    { idx: 37, value: "부국증권", text: "부국증권" },
    { idx: 38, value: "삼성증권", text: "삼성증권" },
    { idx: 39, value: "솔로몬투자증권", text: "솔로몬투자증권" },
    { idx: 40, value: "신영증권", text: "신영증권" },
    { idx: 41, value: "신한금융투자", text: "신한금융투자" },
    { idx: 42, value: "NH투자증권", text: "NH투자증권" },
    { idx: 43, value: "유진투자증권", text: "유진투자증권" },
    { idx: 44, value: "이베스트증권", text: "이베스트증권" },
    { idx: 45, value: "키움증권", text: "키움증권" },
    { idx: 46, value: "하나금융투자", text: "하나금융투자" },
    { idx: 47, value: "하이투자", text: "하이투자" },
    { idx: 48, value: "한국투자", text: "한국투자" },
    { idx: 49, value: "한화증권", text: "한화증권" },
    { idx: 50, value: "KB증권", text: "KB증권" },
    { idx: 51, value: "현대차투자증권", text: "현대차투자증권" },
    { idx: 52, value: "토스뱅크", text: "토스뱅크" },
    { idx: 53, value: "케이프투자증권", text: "케이프투자증권" },
    { idx: 54, value: "SK증권", text: "SK증권" },
    { idx: 55, value: "KTB투자증권", text: "KTB투자증권" },
    { idx: 56, value: "한국포스증권", text: "한국포스증권" },
  ];

  return (
    <SelectFormWrap style={props?.style}>
      <p>{title}</p>
      <SelectCustom
        defaultValue="none"
        onChange={(e) => {
          setRefundType(e.target.value);
        }}
        color={`${refundType !== "none" && "active"}`}
      >
        {selectOption.map((element: any) => (
          <React.Fragment key={element.idx}>
            {element.value === "none" ? (
              <OptionCustom disabled hidden value="none">
                {element.text}
              </OptionCustom>
            ) : (
              <OptionCustom value={element.value}>{element.text}</OptionCustom>
            )}
          </React.Fragment>
        ))}
      </SelectCustom>
    </SelectFormWrap>
  );
};
export default SelectForm;
